import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import ContactCard from "./ContactCard";
import GroupsIcon from "../../assets/icons/groups.svg2";
import { useGetContactFieldsQuery } from "../store/slices/contactsSlice";
import { Link } from "react-router-dom";

export default function ContactsList({
  contacts,
  contactButton,
  allContactsButton,
  refreshList,
  notDraggable,
  fullView,
  isModal,
  showContactFields,
  onSelectContacts,
  highlighChannelsIfNotAvailable = undefined,
}) {
  const {
    data: contactFields,
    isFetching,
    isLoading,
  } = useGetContactFieldsQuery();
  const contactItems = Array.isArray(contacts) ? contacts : [];

  const [selectedContacts, setSelectedContacts] = useState([]);
  useEffect(() => {
    onSelectContacts?.(selectedContacts);
  }, [selectedContacts]);

  return (
    contactFields &&
    (contactFields.length > 0 ? (
      contactItems.length > 0 ? (
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                {onSelectContacts && typeof onSelectContacts === "function" && (
                  <th className=" d-flex p-2 text-nowrap">
                    <Form.Check
                      checked={
                        selectedContacts.length ===
                        contactItems.filter((c) => c).length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedContacts(
                            contactItems.filter((c) => c).map((c) => c.uuid)
                          );
                        } else {
                          setSelectedContacts([]);
                        }
                      }}
                    />
                  </th>
                )}

                {contactButton && <th className="p-2">{allContactsButton} </th>}

                {fullView && <th className="p-2">Status</th>}

                {contactFields
                  .filter(
                    (cf) => cf.isCard || showContactFields?.includes(cf.uuid)
                  )
                  .sort((a, b) => a.order - b.order)
                  .map((field) => (
                    <th key={field.uuid} className="p-2">
                      <span className="text-nowrap text-capitalize">
                        {field.label}
                      </span>
                    </th>
                  ))}

                <th className="p-2 text-nowrap">Comms addresses</th>

                {fullView && (
                  <>
                    <th className="p-2 text-nowrap">Groups</th>
                    <th className="p-2 text-nowrap">Created at</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {contactItems.map((contact) =>
                contact ? (
                  <ContactCard
                    key={contact.uuid}
                    showContactFields={showContactFields}
                    contact={contact}
                    contactButton={contactButton}
                    onEdit={refreshList}
                    notDraggable={notDraggable}
                    contactFields={contactFields}
                    fullView={fullView}
                    isModal={isModal}
                    highlighChannelsIfNotAvailable={
                      highlighChannelsIfNotAvailable
                    }
                    isSelected={selectedContacts.includes(contact.uuid)}
                    onSelect={
                      onSelectContacts && typeof onSelectContacts === "function"
                        ? (selected) => {
                            if (selected) {
                              setSelectedContacts([
                                ...selectedContacts,
                                contact.uuid,
                              ]);
                            } else {
                              setSelectedContacts(
                                selectedContacts.filter(
                                  (c) => c !== contact.uuid
                                )
                              );
                            }
                          }
                        : undefined
                    }
                  />
                ) : (
                  <tr>
                    <td className="text-nowrap p-2" colSpan={4}>
                      Contact not found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center h-100 d-flex flex-column align-items-center justify-content-center opacity-50">
          <div>
            <GroupsIcon width={100} className="my-3" />
          </div>
          <div>Nothing to show</div>
        </div>
      )
    ) : (
      <div className="alert alert-warning text-center">
        No contact fields defined. Please{" "}
        <Link to="/assets/contacts/fields">go to</Link> contacts fields page to
        create fields.
      </div>
    ))
  );
}
